/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { apiUrls } from '../utils'

const { newOOBaseUrl } = apiUrls()

export const globalProductSearch = () => `${newOOBaseUrl}search/product`

export const inStoreProductSearch = (storeId) => `${newOOBaseUrl}search/in-store/${storeId}/product`
